import React from "react";
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <a href="#top" className="flex items-center gap-3" aria-label="Éléonore Para — accueil" data-id="element-126" data-mp="8u4tmrzsq3qi">
      <span className={`flex h-9 w-9 items-center justify-center rounded-md font-display text-sm font-bold ${inverted ? "bg-white text-ink" : "bg-ink text-white"}`} aria-hidden="true" data-id="element-127" data-mp="3qaco1l4rhs11">
        EP
      </span>
      <span className={`font-display text-lg font-semibold leading-none ${inverted ? "text-white" : "text-ink"}`} data-id="element-128" data-mp="mqruh5uvde1p">
        Éléonore Para
      </span>
    </a>;
}